import moment from 'moment';
import { TableCell, TableRow, Tooltip } from '@mui/material'
import { Visibility as VisibilityIcon, OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { trackActivity } from '../../../utils/mixpanel';
import { displayDateFormatShort } from '../../../constants';
import NumericLabel from 'react-pretty-numbers';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const MRFundList = ({ item, onView, viewEventBalance,currency }) => {
const handleItemClicked = (page_type) => {
    trackActivity("Item Clicked", { page_title: `MR Balance Listing`, page_type: page_type });
    };
  return (
    <TableRow>
      <TableCell align="center"> <Tooltip title="View" arrow> <VisibilityIcon fontSize="small" color="primary" onClick={()=>{onView(); handleItemClicked("ViewIcon")}} sx={{ cursor: "pointer" }} /> </Tooltip> </TableCell>
      <TableCell sx={{ minWidth: '100px' }}>{item?.period ? moment(item?.period).format(displayDateFormatShort) : '--'}</TableCell>
      <TableCell sx={{ minWidth: '120px' }}>{item?.event || "--"}</TableCell>
      <TableCell sx={{ minWidth: '100px' }}>{item?.txn_type ||  "--"}</TableCell>
      <TableCell sx={{ minWidth: '90px' }}>
        <span style={{ color: parseFloat(item?.amount) < 0 ? 'red' : 'inherit' }}>
          <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency?.code || 'USD', precision: 2, commafy: true, justification: 'L' }}>{''+item?.amount}</NumericLabel>
        </span>
        {item?.excess_amount > 0 && (
          <Tooltip
            title={<>Excess Amount: <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency?.code, precision: 2, commafy: true, justification: 'L' }}>{item?.excess_amount}</NumericLabel></>}
            arrow
          >
            <InfoOutlinedIcon sx={{ verticalAlign: 'sub', fontSize: '16px', paddingLeft: '5px', color: '#64748b', cursor: 'pointer' }} />
          </Tooltip>
        )}
      </TableCell>
      <TableCell sx={{ minWidth: '120px' }}> <span style={{ color: parseFloat(item?.balance) < 0 ? 'red' : 'inherit' }}><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency?.code || 'USD', precision: 2, commafy: true, justification: 'L' }}>{item?.balance}</NumericLabel></span>
         {item?.is_info === true ? <Tooltip title="View Balance" arrow><OpenInNewIcon  onClick={()=>{viewEventBalance(); handleItemClicked("View Event Balance")}} sx={{ cursor: 'pointer',verticalAlign:"sub",fontSize:"16px",paddingLeft:"5px" }} fontSize='small' color='primary' /></Tooltip> : null}
      </TableCell>
      <TableCell >{item?.transaction ||  "--"}</TableCell>
    </TableRow>
  )
}

export default MRFundList